"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var IdeationStatus = function IdeationStatus(_ref) {
  var ideationStatus = _ref.ideationStatus;
  return (0, _preact.h)("span", {
    style: {
      color: ideationStatus.textColor,
      backgroundColor: ideationStatus.backgroundColor
    },
    className: "idea-status-pill"
  }, ideationStatus.name);
};

var _default = IdeationStatus;
exports.default = _default;